<template>
  <div :class="boxClass">
    <header :class="customHeader" class="flex items-center el-message__content">
        <slot name="headerRight" />
        <div class="flex-none ml-auto" v-if="hasContent">
            <slot name="headerLeft" />
        </div>
        <div class="flex-none ml-auto" v-else>
            <base-button @click="toggle" mode="secondary-phantom" :text="active ? $t('financial_dashboard.see_less') : $t('financial_dashboard.see_more')"  />
        </div>
    </header>
    <transition
      name="collapsible"
      @enter="startTransition"
      @after-enter="endTransition"
      @before-leave="startTransition"
      @after-leave="endTransition"
    >
      <section v-if="active" class="overflow-hidden">
        <div :class="customContent">
            <slot name="content" />
        </div>
      </section>
    </transition>
  </div>
</template>

<script>
import MessageType from '@/classes/enums/MessageType'
export default {
  name: 'base-collapsible-warning',
  props: {
    customHeader: {
      type: String,
      default: ''
    },
    customContent: {
      type: String,
      default: ''
    },
    defaultOpen: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: MessageType.INFO,
      validator: value => Object.values(MessageType).includes(value)
    }
  },
  data: function () {
    return {
      active: false
    }
  },
  mounted () {
    if (this.defaultOpen) this.toggle()
  },
  computed: {
    hasContent: function () {
      return this.$scopedSlots.headerLeft
    },
    finalType: function () {
      switch (this.type) {
        case MessageType.SUCCESS:
        case MessageType.WARNING:
        case MessageType.ERROR:
        case MessageType.INFO:
          return this.type
        default:
          return MessageType.INFO
      }
    },
    boxClass: function () {
      return [
          `el-message--${this.finalType}`,
          `collapsible--${this.finalType}`
      ]
    }
  },
  methods: {
    toggle () {
      this.active = !this.active
    },
    startTransition (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    endTransition (el) {
      el.style.height = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.collapsible--warning {
  @apply bg-yellow-50/95 border-yellow-100 border-2 dark:border-none dark:bg-yellow-800/10;
}
.collapsible--error {
  @apply bg-red-100 border-red-200 border-2 dark:border-none dark:bg-red-800/10;
}
.collapsible--info {
  @apply bg-blue-100 border-blue-100 border-2 dark:border-none dark:bg-blue-800/10;
}
.collapsible-enter-active,
.collapsible-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}
.collapsible-enter,
.collapsible-leave-to {
  height: 0 !important;
}
</style>
